// @ts-nocheck
import React from 'react';
import { XIcon } from './icons';

const TONES = {
  green: { bg: 'var(--mov-accent-soft)', color: 'var(--mov-accent-ink)' },
  gray: { bg: 'var(--mov-chip-gray-bg)', color: 'var(--mov-chip-gray-fg)' },
};

/**
 * Chip — filter-style removable tag. Pass `onRemove` to render an X handle.
 */
const Chip = ({ tone = 'green', onRemove, className = '', children }) => {
  const t = TONES[tone] || TONES.green;
  return (
    <span
      className={['inline-flex items-center gap-1.5', className].join(' ')}
      style={{
        background: t.bg,
        color: t.color,
        borderRadius: 999,
        padding: '4px 8px 4px 10px',
        fontSize: 12,
        fontWeight: 500,
      }}
    >
      {children}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label="Remove"
          className="opacity-60 hover:opacity-100 cursor-pointer"
          style={{ background: 'transparent', border: 0, color: 'inherit', padding: 0, display: 'grid', placeItems: 'center' }}
        >
          <XIcon size={11} strokeWidth={2} />
        </button>
      )}
    </span>
  );
};

export default Chip;
